
import React from "react";
import { Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

interface ApproveButtonProps {
    onApprove: () => void;
    loading?: boolean;
    disabled: boolean;
    requiresSaveFirst?: boolean;
}

const ApproveEventButton: React.FC<ApproveButtonProps> = ({
    onApprove,
    loading,
    disabled,
    requiresSaveFirst = false,
}) => {
    return (
        <Button
            variant="contained"
            color="success"
            startIcon={<CheckIcon />}
            onClick={onApprove}
            disabled={loading || disabled}
            sx={{ ml: 2 }}
        >
            {loading
                ? "Approving..."
                : disabled
                    ? (requiresSaveFirst ? "Save before approve" : "Approved")
                    : "Approve"}
        </Button>
    );
};

export default ApproveEventButton;
